import React, { Fragment, useState, useContext, useRef } from 'react';
import { ControlBar, BigPlayButton, Player } from 'video-react';
import { useTranslation } from 'react-i18next';
import {  Grid, Button, Icon, Fab, AppBar, Dialog, Toolbar, Input, Modal,
    DialogContent, DialogTitle, CircularProgress, LinearProgress, Backdrop,
    MenuItem, FormHelperText, Select, FormControl, DialogActions,
    ListItem, Divider } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Flag, Send, GTranslate } from '@material-ui/icons';
import Typography from '@material-ui/core/Typography';
import { DialogAcceptButton, DialogCancelButton, DialogGrayCancelButton, isObjEmpty,
    Transition, ExamStatus, ReportStatus, DogGender } from '../../Common.js';
import firebase from '../../Firebase.js';
import { TrainerContext } from '../../contexts/TrainerContext.js';
import { languageOptions } from '../../i18n.js';
import { Virtuoso } from 'react-virtuoso';
import { formatRelative } from 'date-fns';
import { es, ru, sv, lt, enUS,  } from 'date-fns/locale';
import { AuthContext } from '../../contexts/AuthContext';
const examControlsRowHeight = '70px';

const getStatusIcon = s => {
    switch (s) {
        case ExamStatus.APPROVED:
            return 'check';
        case ExamStatus.REJECTED:
            return 'close';
        // case ExamStatus.INAPPROPRIATE:
        //   return 'flag';
        // case ExamStatus.TECHNICAL_ISSUE:
        //   return 'flag';
        default:
            return '';
    }
};

const useStyles = makeStyles(
    (theme) =>
        createStyles({
            container: {
                [theme.breakpoints.up('sm')] : {
                    height: `calc(100% - 64px)`
                },
                [theme.breakpoints.down('xs')] : {
                    height: `calc(100% - 56px)`
                },
            },
            controls: {
                height: 200,
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
            },
            quickRepliesList: {
                [theme.breakpoints.up('sm')] : {
                    height: `calc(100% - 64px - 200px) !important`
                },
                [theme.breakpoints.down('xs')] : {
                    height: `calc(100% - 56px - 200px) !important`
                },
                '-webkit-overflow-scrolling': 'touch',
            },
            videoContainer: {
                [theme.breakpoints.up('sm')] : {
                    height: `calc(100% - ${examControlsRowHeight})`
                },
                [theme.breakpoints.down('xs')] : {
                    height: `calc(100% - ${examControlsRowHeight})`
                },
                flexGrow: 1,
                position: 'relative',
            },
            examControls: {
                height: examControlsRowHeight,
            },
            flagBtn: {
                background: theme.palette.primary.main,
                '&:hover': {
                    background: theme.palette.primary.main,
                },
            },
            skipBtn: {
                borderRadius: 25,
                background: theme.palette.primary.main,
                '&:hover': {
                    background: theme.palette.primary.main,
                },
            },
            acceptBtn: {
                borderRadius: 25,
                background: theme.palette.secondary.main,
                color: theme.palette.primary.main,
                '&:hover': {
                    background: theme.palette.secondary.main,
                },
            },
            rejectBtn: {
                borderRadius: 25,
                background: theme.palette.primary.red,
                color: theme.palette.primary.main,
                '&:hover': {
                    background: theme.palette.primary.red,
                },
            },
            translateToBtn: {
                borderRadius: 25,
                background: '#f5e365',
            },
            examInfoBox: {
                position: 'absolute',
                bottom: 0,
                backgroundImage: 'linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0.2))',
                color: theme.palette.primary.main,
                paddingRight: 20,
                paddingLeft: 20,
            },
            topLabelRed: {
                position: 'absolute',
                top: 0,
                right: 0,
                width: 0,
                height: 0,
                borderTop: `80px solid ${theme.palette.primary.red}`,
                borderLeft: '80px solid transparent',
            },
            topLabelGreen: {
                position: 'absolute',
                top: 0,
                right: 0,
                width: 0,
                height: 0,
                borderTop: `80px solid ${theme.palette.primary.green}`,
                borderLeft: '80px solid transparent',
            },
            topLabelIcon: {
                position: 'absolute',
                top: 7,
                right: 7,
                color: theme.palette.primary.main,
            },
            firstInfoRow: {
                paddingTop: theme.spacing(1),
                paddingBottom: theme.spacing(1),
            },
            infoRow: {
                paddingBottom: theme.spacing(1),
            },
            label: {
                color: '#602d22',
                background: '#f5e365',
                paddingRight: 5,
                paddingLeft: 5,
                borderRadius: 5,
                textTransform: 'uppercase',
            },
            reportLabel: {
                color: theme.palette.primary.main,
                background: theme.palette.primary.red,
                paddingRight: 5,
                paddingLeft: 5,
                marginLeft: 5,
                borderRadius: 5,
                textTransform: 'uppercase',
            },
            appBar: {
                position: 'relative',
            },
            title: {
                textAlign: 'center',
                flex: 1,
            },
            quickResponseListItem: {
                paddingLeft: 0,
                paddingRight: 0,
            },
            replyTextBox: {
                background: '#F8F8F8',
                width: '100%',
                marginTop: theme.spacing(1),
                height: '80px',
                // maxHeight: '50px',
                overflow: 'scroll',
            },
            repliesViewContent: {
                overflow: 'auto',
                backgroundColor: theme.palette.background.paper,
                paddingTop: 0,
            },
            dialogContent: {
                padding: 0,
            },
            flagSpinner: {
                color: '#f62152'
            },
            sendAccepting: {
                zIndex: 20,
                position: 'absolute',
                bottom: theme.spacing(2),
                right: theme.spacing(2),
                color: theme.palette.primary.main,
                background: theme.palette.primary.green,
                '&:hover': {
                    background: theme.palette.primary.green,
                },
            },
            sendRejecting: {
                zIndex: 20,
                position: 'absolute',
                bottom: theme.spacing(2),
                right: theme.spacing(2),
                color: theme.palette.primary.main,
                background: theme.palette.primary.red,
                '&:hover': {
                    background: theme.palette.primary.red,
                },
            },
            getExamLoading: {
                [theme.breakpoints.up('sm')] : {
                    height: `calc(100% - 64px)`
                },
                [theme.breakpoints.down('xs')] : {
                    height: `calc(100% - 56px)`
                }
            },
        }),
);

const dogGenderIcon = dogGender => {
    switch (dogGender) {
        case DogGender.UNKNOWN:
            return '🤷🏼‍♀️';
        case DogGender.FEMALE:
            return '♀';
        case DogGender.MALE:
            return '♂';
        case DogGender.OTHER:
            return '⚧';
    }
};

const ExamInfoBox = ({ examData, gettingExam, getExam, showExamInstruction, getTranslatedExamInstruction }) => {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const { tricks } = useContext(TrainerContext);
    const lmap = {lt, es, ru, sv, en: enUS};
    const getTrick = (trickId) => {
        const targetLang = i18n.language === 'en-US' ? 'en' : i18n.language;
        let trick = tricks.filter((item) => item.id === trickId && item.locale === targetLang)
        return trick[0]
    }
    return (
        <Grid container direction='column' className={classes.examInfoBox}>
            <Grid item className={classes.firstInfoRow}>
                <Grid container align-item='flex-end'>
                    { examData.isDogPremium ?
                        (<Grid item style={{marginRight: '1rem'}}>
                            <Typography variant='body2' className={classes.label}>
                                {t('premium')}
                            </Typography>
                        </Grid>) : '' }
                    <Grid item>
                        {
                            examData.resubmitted &&
                            <Typography variant='body2' className={classes.label}>
                                { t('resubmitted') }
                            </Typography>
                        }
                    </Grid>
                    <Grid item>
                        {
                            examData.reportStatus >= 0 &&
                            <Typography variant='body2' className={classes.reportLabel}>
                                { examData.reportStatus === ReportStatus.INAPPROPRIATE ? t('inappropriate') : t('technical_issue') }
                            </Typography>
                        }
                    </Grid>
                </Grid>
            </Grid>
            <Grid item className={classes.infoRow}>
                <Grid container justify='space-between' align-item='flex-end'>
                    <Grid item>
                        <Typography variant='h5' >
                            { (examData.dogName || t('no-name')) + ' ' + dogGenderIcon(examData.dogGender) }
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Grid container alignItems='flex-end'>
                            <Grid item style={{marginRight: '0.5rem'}}>
                                <img alt={examData.userLocale + ' flag'} height='20' src={`/img/${examData.userLocale}.svg`}/>
                            </Grid>
                            <Grid item>
                                <Typography variant='h6' >
                                    { examData.userLocale }
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item className={classes.infoRow} onClick={() => {                
                if (examData.hasOwnProperty('instructions') && examData.instructions[i18n.language] != undefined) {
                    showExamInstruction(true)
                } else {                    
                    getTranslatedExamInstruction()
                }
            }}>
                <Grid container justify='space-between' align-item='flex-end'>
                    <Grid item>
                        <Grid container>
                            <Grid item>
                                {
                                    isObjEmpty(tricks)
                                        ? <CircularProgress size={24} className={classes.flagSpinner} />
                                        : <Typography variant='body1' style={{marginRight: '0.5rem'}}>
                                            { getTrick(examData.trickId).name }
                                        </Typography>
                                }
                            </Grid>
                            <Grid item>
                                <Icon> info </Icon>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Typography variant='body1' >
                            {examData.submittionDate && formatRelative(examData.submittionDate.toDate(), new Date(), {locale: lmap[i18n.language]})}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

const ReportExamView = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { examData, flagDialogState, setFlagDialogState, getExam, editCb, skipExam, updateExamUi, featureVideo } = props;
    const [loading, setLoading] = useState(false);
    const [flaggedWithStatus, setFlaggedWithStatus] = useState('');

    const flagExam = async (status, reportStatus) => {
        try {
            await firebase.firestore().doc(examData.docPath)
                .set({status,
                    active: true,
                    reportStatus,
                    reviewDate: firebase.firestore.Timestamp.now(),
                    evaluatedByEmail: firebase.auth().currentUser.email,
                    evaluatedByAvatar: firebase.auth().currentUser.photoURL,}, {merge: true});
        }
        catch (err) {
            console.log('err is flagging the exam', err);
        }
    };

    const reportAs = (s) => async () => {
        const newStatus = s === ReportStatus.INAPPROPRIATE ? ExamStatus.REJECTED : examData.status;
        setFlaggedWithStatus(s);
        setLoading(true);
        await flagExam(newStatus, s);
        setLoading(false);
        setFlaggedWithStatus('');
        setFlagDialogState(false);
        if (editCb) {
            editCb({ status: newStatus, reportStatus: s });
        }
        else if (s === ReportStatus.INAPPROPRIATE) {
            getExam();
        }
        else if (s === ReportStatus.TECHNICAL_ISSUE) {
            updateExamUi({ reportStatus: s });
        }
        // else {
        //   s === ReportStatus.TECHNICAL_ISSUE ? skipExam() : getExam();
        // }
    };

    return (
        <Dialog open={flagDialogState}
                onClose={() => {
                    if (loading) {
                        return;
                    }
                    setFlagDialogState(false);
                }}
                fullWidth
                aria-labelledby='flag-this-exam'>
            <DialogTitle style={{textAlign: 'center'}} onClose={() => {}}>
                { t('report-this-exam') }
            </DialogTitle>
            <DialogContent className={classes.dialogContent} dividers>
                <DialogCancelButton fullWidth
                                    disabled={loading}
                                    onClick={reportAs(ReportStatus.INAPPROPRIATE)}>
                    {
                        (loading && ReportStatus.INAPPROPRIATE === flaggedWithStatus) ?
                            (<CircularProgress size={24} className={classes.flagSpinner} />) :
                            t('report-as-inappropriate')
                    }
                </DialogCancelButton>
                <Divider/>

                <DialogCancelButton fullWidth
                                    disabled={loading}
                                    onClick={reportAs(ReportStatus.TECHNICAL_ISSUE)}>
                    {
                        (loading && ReportStatus.TECHNICAL_ISSUE === flaggedWithStatus) ?
                            (<CircularProgress size={24} className={classes.flagSpinner} />) :
                            t('report-as-technical-issue')
                    }
                </DialogCancelButton>
                <Divider/>

                <DialogAcceptButton fullWidth
                                    disabled={loading}
                                    onClick={() => {
                                        setFlagDialogState(false);
                                        featureVideo();
                                    }}>
                    {
                        (loading && ReportStatus.TECHNICAL_ISSUE === flaggedWithStatus) ?
                            (<CircularProgress size={24} className={classes.flagSpinner} />) :
                            t('feature-video')
                    }
                </DialogAcceptButton>
                <Divider/>

                <DialogGrayCancelButton fullWidth
                                        disabled={loading}
                                        onClick={() => {
                                            setFlagDialogState(false);
                                            props.videoRef.current.play();
                                        }}>
                    { t('cancel') }
                </DialogGrayCancelButton>
            </DialogContent>
        </Dialog>
    );
};

const Spinner = ({msg}) => {
    const { t } = useTranslation();
    return (
        <Dialog open>
            <DialogContent>
                <Typography variant='subtitle1'> {t(msg)} </Typography>
                <LinearProgress color="secondary" />
            </DialogContent>
        </Dialog>
    );
};

const ExamInstruction = ({ showExamInstruction, examData }) => {
    const { i18n, t } = useTranslation();
    const targetLang = i18n.language === 'en-US' && examData.instructions.hasOwnProperty('en') ? 'en' : i18n.language;
    return (
        <Dialog open>
            <DialogTitle>
                {t('exam-instruction')}
            </DialogTitle>
            <DialogContent>
                <Typography variant='subtitle1'> {examData.instructions[targetLang]} </Typography>
            </DialogContent>
            <DialogGrayCancelButton fullWidth
                                    onClick={() => {
                                        showExamInstruction(false);
                                    }}>
                {t('cancel')}
            </DialogGrayCancelButton>
        </Dialog>
    );
};

export default ({ examData, gettingExam, getExam, skipExam, editCb, updateExamUi, featureVideo, featureExam }) => {
    const classes = useStyles();
    const { i18n, t } = useTranslation();
    const [replyDialogState, setReplyDialogState] = useState({open: false, isAccepted: false});
    const [flagDialogState, setFlagDialogState] = useState(false);
    const [examInstruction, showExamInstruction] = useState(false);
    const { examReasons, defaultComments } = useContext(TrainerContext);
    const { authUser, updateAuthUser } = useContext(AuthContext);
    const replyTextRef = useRef();
    const getTranslatedExamInstruction = async () => {
        const targetLang = i18n.language === 'en-US' ? 'en' : i18n.language;
        const trickDetail = await firebase.firestore()
                                .collection("app.tricks")
                                .doc(examData.trickId)
                                .collection("trickTranslations")
                                .doc(targetLang).get()          
          if (examData.instructions === undefined) {
            examData.instructions = {}
          }
        examData.instructions[targetLang] = trickDetail.data().examInstructions
        showExamInstruction(true)
    }   

    const closeReplyDialog = () => {
        setReplyDialogState({open: false, isAccepted: false});
        videoRef.current.play();
    };

    const videoRef = useRef();

    const freqUsedFirst = () => {
        const targetLang = i18n.language === 'en-US' ? 'en' : i18n.language;
        let commentsFilterByLang = examReasons.filter(item => item.locale === targetLang)
        let examComments = commentsFilterByLang.filter(item => item.trick.id === examData.trickId)            
        if (examComments.length > 0) {
            if (replyDialogState.isAccepted)  {
                return examComments[0].acceptanceComments
            } else {
                return examComments[0].rejectionComments
            }
        }
        return defaultCommentsList()
    }

    const defaultCommentsList = () => {
        const targetLang = i18n.language === 'en-US' ? 'en' : i18n.language;
        let defaultCommentsFilterByLang = defaultComments.filter(item => item.locale === targetLang)
        if (defaultCommentsFilterByLang === undefined) {
            return []
        } else {
            return defaultCommentsFilterByLang;
        }
    }

    const [replyLanguage, setReplyLanguage] = useState(examData.userLocale);
    const [replyText, setReplyText] = useState(examData.reviewComment || '');

    const [searchText, setSearchText] = useState('');
    const [evaluating, setEvaluating] = useState(false);
    const [extraTxt, setExtraTxt] = useState('');
    const [translating, setTranslating] = useState(false);
    const [showTranslate, setShowTranslate] = useState(false);

    const filteredFreqUsedFirst = searchText ?
        defaultCommentsList().filter((item) => { 
            return item.text.toLowerCase().includes(searchText.trim().toLowerCase()) 
        }) : freqUsedFirst()
    
    const scrollToTop = _ => {
        setTimeout(() => {
            replyTextRef.current.scrollTop = replyTextRef.current.scrollHeight;
        }, 10);
    };

    const replaceNameNameNameWithDogNameIfNeeded = (str) => {
        if (!examData.dogName) {
            return
        }
        const nameNameName = [
            "NameNameName",
            "NombreNombreNombre",
            "КличкаКличкаКличка",
            "NomNomNomNom",
            "VardasVardasVardas",
            "NomeNomeNome",
            "名前、名前、名前",
            "ImięImięImię"
        ]
        let length = nameNameName.length
        while (length--) {
            let tempRegex = nameNameName[length]
            if (str.includes(tempRegex)) {
                return str.replace(tempRegex, examData.dogName + examData.dogName + examData.dogName)
            }
        }
        return str
    }
    const replaceWithDogNameAndAddGender = (item) => {
        if (!examData.dogName) {
            return item.text
        }
        const regsName = {
            'en-US': /the dog|your dog/gi,
            'de': /dein Hund|deinem Hund|deinen Hund|der Hund|des Hund|den Hund/gi,
            'es': /el perro|al perro|tu perro|del perro/gi,
            'ru': /Собака/gi,
            'fr': /Ton chien|au chien|le chien|du chien/gi,
            'pt': /o seu cachorro|o cachorro/gi,
            'nl': /jouw hond|je hond/gi,
            'lt': /jūsų šuo|šuo/gi,
            'pl': /twój pies|pies|twój pies/gi,
            'ja': /イヌが|そのイヌ|あなたのイヌ/gi,
            'sv': /din hund|hundens|hunden/gi,
            'it': /il cane|il tuo cane|al cane|del cane/gi,
            'uk': /Собака/gi,
        };
        const regsGender = gender => {
            return language => {
                const regs = {
                    'en-US': [{ reg: / he\/she | he | they /gi, substituteWith: gender === DogGender.FEMALE ? ' she ' : ' he ' },
                        { reg: / his\/hers | him\/her | his | their /gi, substituteWith: gender === DogGender.FEMALE ? ' her ' : ' his ' }],
                    'de': [{ reg: / er\/sie | ihn\/sie | er /gi, substituteWith: gender === DogGender.FEMALE ? ' sie ' : ' er ' },
                        { reg: / sein\/ihr | sein | his | their /gi, substituteWith: gender === DogGender.FEMALE ? ' ihr ' : ' sein ' },
                        { reg: / seine\/ihre | seine /gi, substituteWith: gender === DogGender.FEMALE ? ' ihre ' : ' seine ' }],
                    'es': [],
                    'ru': [],
                    'fr': [{ reg: / qu'il\/elle /gi, substituteWith: gender === DogGender.FEMALE ? ' qu\'elle ' : ' qu\'il ' },
                        { reg: / au chien\/à la chienne /gi, substituteWith: gender === DogGender.FEMALE ? ' à la chienne ' : ' au chien ' }],
                    'pt': [{ reg: / ele\/ela | ele /gi, substituteWith: gender === DogGender.FEMALE ? ' ela ' : ' ele ' },
                        { reg: / dele\/dela | dele /gi, substituteWith: gender === DogGender.FEMALE ? ' dela ' : ' dele ' }],
                    'nl': [{ reg: / hij\/zij | hij /gi, substituteWith: gender === DogGender.FEMALE ? ' zij ' : ' hij ' },
                        { reg: / zijn\/haar | zijn\/haar | zijn /gi, substituteWith: gender === DogGender.FEMALE ? ' haar ' : ' zijn ' }],
                    'lt': [{ reg: / jis\/ji | ji /gi, substituteWith: gender === DogGender.FEMALE ? ' hi ' : ' his ' },
                        { reg: / jo\/jos | jos /gi, substituteWith: gender === DogGender.FEMALE ? ' jos ' : ' jo ' },
                        { reg: / jam\/jai /gi, substituteWith: gender === DogGender.FEMALE ? ' jai ' : ' jam ' }],
                    'pl': [{ reg: / on\/ona | on | oni /gi, substituteWith: gender === DogGender.FEMALE ? ' ona ' : ' on ' },
                        { reg: / jego\/jej | jego\/jej | jego | ich /gi, substituteWith: gender === DogGender.FEMALE ? ' jej ' : ' jego'}],
                    'sv':  [{ reg: / han\/hon | han | de /gi, substituteWith: gender === DogGender.FEMALE ? ' hon ' : ' han ' },
                        { reg: / hans\/henne | honom\/henne | hans | deras /gi, substituteWith: gender === DogGender.FEMALE ? ' henne ' : ' hans ' }],
                    'ja': [{ reg: / 彼\/彼女 | 彼 | 彼ら /gi, substituteWith: gender === DogGender.FEMALE ? ' 彼女 ' : ' 彼 ' }],
                    'it': [{ reg: / lui\/ lei | lui | loro /gi, substituteWith: gender === DogGender.FEMALE ? ' lei ' : ' lui '},
                            { reg: / suo\/sua | lui\/lei | suo | loro /gi, substituteWith: gender === DogGender.FEMALE ? ' sua ' : ' suo ' }],
                    'uk': [],
                };
                return regs[language];
            };
        };        
        let str = item.text
        if (regsName[replyLanguage]) {
            str = str.replace(regsName[replyLanguage], examData.dogName);
        }

        if (examData.dogGender === DogGender.FEMALE || examData.dogGender === DogGender.MALE) {
            regsGender(examData.dogGender)(replyLanguage).forEach(i => {
                str = str.replace(i.reg, i.substituteWith);
            });
        }
        str = replaceNameNameNameWithDogNameIfNeeded(str)
        return str;
    };

    const translateSelectedComment = (itemId) => {
        let targetLang = replyLanguage === 'en-US' ? 'en' : replyLanguage;
        let examComments = defaultComments.filter((item => item.locale === targetLang && item.contentfulId === itemId))
        if (examComments.length > 0) {
            return examComments[0]
        } else {
            return []
        }        
    }

    const fillReplyByExamLang = itemId => () => {
        let item = translateSelectedComment(itemId)
        setReplyText((!!replyText)
          ? replyText + " " + replaceWithDogNameAndAddGender(item)
          : replaceWithDogNameAndAddGender(item)
        );
        setSearchText('')
        scrollToTop();
    };

    const cleanupDialogLocalStateAndClose = () => {
        closeReplyDialog();
        setReplyText('');
        setSearchText('');
        setExtraTxt('');
        setEvaluating(false);
    };

    const translateTxt = async () => {
        setTranslating(true);
        const targetLang = replyLanguage === 'en-US' ? 'en' : replyLanguage;
        try {
            const txt = await firebase.functions().httpsCallable('translateTxtTrainer')({ txt: extraTxt, targetLang });
            setReplyText(replyText + ' ' + txt.data[0]);
            setTranslating(false);
            setShowTranslate(false);
            scrollToTop();
        }
        catch (err) {
            setTranslating(false);
            setShowTranslate(false);
            console.log('translating the error ', err);
        }
    };

    const evalExam = (status) => async () => {
        try {
            setEvaluating(true);
            const updatedFields = {
                status,
                active: true,
                adminId: null,
                reviewDate: firebase.firestore.Timestamp.now(),
                evaluatedByEmail: firebase.auth().currentUser.email,
                evaluatedByAvatar: firebase.auth().currentUser.photoURL,
                reviewComment: replyText
            };
            const batch = firebase.firestore().batch();
            const ref = firebase.firestore().doc(examData.docPath);
            batch.update(ref, updatedFields);
            await batch.commit();
            cleanupDialogLocalStateAndClose();            
            // editCb: is to check if the trainer is editing an already reveiwed exam from fininshed exam list or reviewing a new exam
            // if yes call the editCb to send updated fields
            // if its new exam get the next exam to review and update the trainers numberOfReviews exams
            if (!!editCb) {
                editCb(updatedFields);              
            } else {
                getExam();
                updateAuthUser({ numberOfReviews: authUser.numberOfReviews + 1 });                            
            }
        }
        catch (err) {
            console.log('err evaluating exam', err);
        }
    };

    const ReplyRow = (index) => {
        return (
            <Fragment>
                <ListItem button
                          onClick={fillReplyByExamLang(filteredFreqUsedFirst[index].id)}
                          style={filteredFreqUsedFirst[index].fqu ? { borderLeft: '5px solid #f5e365' } : {}}>
                    {filteredFreqUsedFirst[index].text}
                </ListItem>
                <Divider />
            </Fragment>
        );
    };

    return (
        <div style={{height: '100%'}}>
            { gettingExam && <Spinner msg='getting-next-exam'></Spinner> }
            { featureExam && <Spinner msg='feature-video'></Spinner>}
            {examInstruction && <ExamInstruction showExamInstruction={showExamInstruction} examData={examData} />}
            {Object.keys(examData).length === 0
                ? <Grid className={classes.getExamLoading} container justify='center' alignItems='center'>
                    <Grid item container direction='column' justify='center' alignItems='center'>
                        <Typography align='center' variant='h5' style={{paddingBottom: '1em'}}>
                            { t('no-exams-to-eval') }
                        </Typography>
                        <Button className={classes.skipBtn}
                                onClick={getExam}
                                variant='contained'>
                            { t('check-for-new-exams') }
                        </Button>
                    </Grid>
                </Grid>
                : <Fragment>
                    <Grid item className={classes.videoContainer}>
                        <Player fluid={false}
                                playsInline
                                height='100%'
                                autoPlay
                                loop
                                ref={videoRef}
                                src={examData.videoUrl}>
                            <BigPlayButton position='center' />
                            <ControlBar disableCompletely={true} >
                            </ControlBar>
                        </Player>
                        {
                            editCb &&
                            <Fragment>
                                <div className={examData.status === ExamStatus.APPROVED ? classes.topLabelGreen : classes.topLabelRed}> </div>
                                <Icon fontSize='large'
                                      className={classes.topLabelIcon}>
                                    { getStatusIcon(examData.status) }
                                </Icon>
                            </Fragment>
                        }
                        <ExamInfoBox examData={examData} showExamInstruction = {showExamInstruction} getTranslatedExamInstruction = {getTranslatedExamInstruction} />
                    </Grid>
                    <Grid item className={classes.examControls}>
                        <Grid container direction='row' justify='space-around' alignItems='center'  style={{height: '100%'}}>
                            <Fab size='small'
                                 color='primary'
                                 aria-label='flag exam button' className={classes.margin}
                                 onClick={() => {
                                     videoRef.current.pause();
                                     setFlagDialogState(true);
                                 }}>
                                <Flag />
                            </Fab>
                            {
                                !editCb && <Button label='skip'
                                                   variant='contained'
                                                   onClick={() => {
                                                       cleanupDialogLocalStateAndClose();
                                                       skipExam();
                                                   }}
                                                   className={classes.skipBtn}>
                                    { t('skip') }
                                </Button>
                            }
                            <Button label='reject'
                                    variant='contained'
                                    className={classes.rejectBtn}
                                    onClick={() => {
                                        videoRef.current.pause();
                                        setReplyLanguage(examData.userLocale);
                                        setReplyDialogState({open: true, isAccepted: false});
                                    }}>
                                <Icon> close </Icon>
                            </Button>
                            <Button label='accept'
                                    variant='contained'
                                    className={classes.acceptBtn}
                                    onClick={() => {
                                        videoRef.current.pause();
                                        setReplyLanguage(examData.userLocale);
                                        setReplyDialogState({open: true, isAccepted: true});
                                    }}>
                                <Icon> check </Icon>
                            </Button>
                        </Grid>
                        <Dialog fullScreen
                                open={replyDialogState.open}
                                onClose={closeReplyDialog}
                                TransitionComponent={Transition}>
                            <AppBar className={classes.appBar}>
                                <Toolbar disableGutters>
                                    <Grid container>
                                        <Grid item xs={3}>
                                            <Button color='secondary' onClick={cleanupDialogLocalStateAndClose}>
                                                { t('cancel') }
                                            </Button>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography noWrap edge='center' variant='h6' className={classes.title}>
                                                { replyDialogState.isAccepted ? t('pass-exam') : t('fail-exam')}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={3}>
                                        </Grid>
                                    </Grid>
                                </Toolbar>
                            </AppBar>
                            <Modal open={evaluating}
                                   BackdropComponent={Backdrop}
                                   disableAutoFocus
                                   disableEnforceFocus
                                   BackdropProps={{invisible: true}}>
                                <div></div>
                            </Modal>
                            <Grid item container className={classes.controls} alignItems='center'>
                                <Grid container style={{position: 'relative'}}>
		    <textarea
                value={replyText}
                ref={replyTextRef}
                style={{resize: 'none',
                    width: '100%',
                    fontFamily: 'Roboto',
                    borderTop: 'none',
                    borderLeft: 'none',
                    borderRight: 'none'}}
                onChange={(e) => setReplyText(e.target.value)}
                rows={5} />
                                    <Icon fontSize='small'
                                          onClick={() => setReplyText('')}
                                          style={{color: '#f62152',
                                              position: 'absolute',
                                              bottom: 0,
                                              right: 0,
                                              display: replyText ? 'block' : 'none'}}>
                                        clear
                                    </Icon>
                                </Grid>
                                <Grid container item justify='space-between' alignItems='flex-end'>
                                    <Grid item xs={7}>
                                        <Input
                                            value={searchText}
                                            type='search'
                                            onChange={(e) => {
                                                setSearchText(e.target.value);
                                            }}
                                            fullWidth
                                            placeholder={t('search-replies')}
                                            inputProps={{'aria-label': t('email') }}/>
                                    </Grid>
                                    <Grid item container justify='center' xs={4}>
                                        <FormControl className={classes.replyLangSelect}>
                                            <Select
                                                value={replyLanguage}
                                                onChange={e => setReplyLanguage(e.target.value)}>
                                                {languageOptions.map((lang) => {
                                                    return (
                                                        <MenuItem key={lang.key}
                                                                  value={lang.key}>
                                                            { lang.label }
                                                        </MenuItem>
                                                    );
                                                })}
                                            </Select>
                                            <FormHelperText>Reply language</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={1}>
                                        { evaluating
                                            ?<CircularProgress size={20} color='secondary'/>
                                            : <Fab size='small'
                                                   onClick={() => setShowTranslate(true)}
                                                   style={{color: '#4F8BF5'}}>
                                                <GTranslate/>
                                            </Fab>
                                        }
                                    </Grid>
                                </Grid>
                                <Grid item container alignItems='flex-end'>
                                    <Typography egde='bottom' variant='caption' className={classes.label}>
                                        {t('frequently-used-replies-for-this-trick')}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Fab aria-label={t('send')}
                                 disabled={!replyText}
                                 onClick={evalExam(replyDialogState.isAccepted ? ExamStatus.APPROVED : ExamStatus.REJECTED)}
                                 className={replyDialogState.isAccepted ? classes.sendAccepting : classes.sendRejecting}>
                                <Send />
                            </Fab>
                            <Dialog open={showTranslate}
                                    onClose={() => {}}>
                                <DialogTitle>
                                    {t('add-message-to-translate')}
                                </DialogTitle>
                                <DialogContent>
                                    <Input value={extraTxt}
                                           onChange={(e) => {setExtraTxt(e.target.value);}}
                                           fullWidth
                                           autoFocus
                                           multiline
                                           rows={3}
                                           placeholder={t('write-your-text')} />
                                </DialogContent>
                                <DialogActions>
                                    <Grid container justify='space-between'>
                                        <Button onClick={()=> setShowTranslate(false)}
                                                disabled={translating}
                                                color="secondary">
                                            {t('cancel')}
                                        </Button>
                                        <Button onClick={translateTxt}
                                                disabled={false}
                                                color="secondary">
                                            { translating ? (<CircularProgress size={20} color='secondary' />) : t('translate') }
                                        </Button>
                                    </Grid>
                                </DialogActions>
                            </Dialog>
                            <Virtuoso
                                className={classes.quickRepliesList}
                                overscan={10}
                                totalCount={filteredFreqUsedFirst.length}
                                item={ReplyRow} />
                        </Dialog>
                        <ReportExamView flagDialogState={flagDialogState}
                                        setFlagDialogState={setFlagDialogState}
                                        examData={examData}
                                        updateExamUi={updateExamUi}
                                        editCb={editCb}
                                        videoRef={videoRef}
                                        skipExam={skipExam}
                                        getExam={getExam}
                                        featureVideo={featureVideo}
                        />
                    </Grid>
                </Fragment>
            }
        </div>
    );
};
